'use client';

import dynamic from 'next/dynamic';

//* Components
import Page from '@/components/global/Page';
import HeroSection from '@/components/sections/HeroSection';
import BeforeAfterSection from '@/components/sections/BeforeAfterSection';

const InfosSection = dynamic(() => import('./components/InfosSection'), { ssr: false });
const GetItTouchSection = dynamic(() => import('@/components/sections/GetItTouchSection'), { ssr: false });
const FAQSection = dynamic(() => import('@/components/sections/FAQSection'), { ssr: false });

//* Style
import ServicesIndividualPageStyle from '@/styles/pages/ServicesIndividualPageStyle';

export default function ServicesIndividualTemplate({ pageData }) {
	return (
		<Page className={'services-individual'}>
			<ServicesIndividualPageStyle>
				<HeroSection {...pageData.hero} />

				<InfosSection data={pageData.infos} />

				<BeforeAfterSection {...pageData.before_after_section} />

				<GetItTouchSection isDark />

				<FAQSection />
			</ServicesIndividualPageStyle>
		</Page>
	);
}
